/* eslint-disable */
import React, {useState} from "react";
import {signOutCurrentUser} from "@/apis/auth";
import {useDispatch} from 'react-redux';
import {setAuthenticated, setCurrentUser, setRegisterComplete} from '@/store/slices/authSlice';
import {removeDecimals, removeRegisterStatus, removeToken, removeUser} from "@/helpers/local-storage";
import {goURL} from "@/helpers/router";
import {toastError} from "@/helpers/toast";
import {Icon} from '@iconify/react';
import {Box, MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";

const SignOutButton = (): any => {
    const [submitting, setSubmitting] = useState(false);
    
    const {t} = useTranslation();

    const dispatch = useDispatch();

    const handleClick = () => {
        setSubmitting(true)

        signOutCurrentUser()
            .then(() => {
                dispatch(setAuthenticated(false));
                dispatch(setCurrentUser(null));
                dispatch(setRegisterComplete(false));
                removeToken()
                removeUser()
                removeDecimals()
                removeRegisterStatus()
                goURL('/auth/login');
            })
            .catch((error) => {
                toastError(error.data.message)
            })
            .finally(() => {
                setSubmitting(false)
            });
    }

    return (
        <MenuItem
            disabled={submitting}
            component={'span'}
            onClick={handleClick}
            sx={{typography: 'body2', py: 1, px: 2.5, mb: 1}}
        >
            <Box
                component={Icon}
                sx={{
                    mr: 2,
                    width: 24,
                    height: 24
                }}
            />
            {t("login.logout")}
        </MenuItem>
    );
}

export default SignOutButton;
